import { string } from 'prop-types';

import React, { Component } from 'react';

const supportEmail = 'Support@veritone.com';

class DeprecatedDataDisclaimer extends Component {
  static propTypes = {
    tabName: string
  };

  static defaultProps = {
    tabName: ''
  };

  render() {
    const { tabName } = this.props;
    return (
      <span>
        {tabName} data is not available with GA4 at the moment. We will incorporate 
        additional data as soon as it becomes available. Please contact your Customer 
        Success Manager or {' '}
        <a href={`mailto:${supportEmail}`}>{supportEmail}</a>{' '}
        for more information.
      </span>
    );
  }
}

export default DeprecatedDataDisclaimer;